import React, { useState, useEffect } from "react";
import axios from "axios";
import UserNavbar from "./UserNavbar";
import { useDashboard } from "../contexts/DashboardContext";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import * as XLSX from "xlsx";

const QueryEditor = () => {
  const [query, setQuery] = useState("");
  const [postsPerPage] = useState(15);
  const [allAlertsData, setAllAlertsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [dropdownIndex, setDropdownIndex] = useState(-1);
  const [tableTab, setTableTab] = useState("table");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { setActiveNav } = useDashboard();
  const token = Cookies.get("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/signin");
    } else {
      axios
        .get("/api/token/isLoggedIn", {
          headers: {
            "x-auth-token": token,
          },
        })
        .then((res) => console.log(res.data))
        .catch(() => navigate("/signin"));
    }
  }, []);

  useEffect(() => {
    setActiveNav("console");
  }, []);

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        "api/system/console",
        { userQuery: query },
        {
          headers: {
            "x-auth-token": token,
          },
        }
      )
      .then((res) => {
        setAllAlertsData(
          res.data.sort(
            (a, b) =>
              new Date(b._source.timestamp) - new Date(a._source.timestamp)
          )
        );
      })
      .catch((err) => {
        console.error("Error during API call:", err);
        setError(err.response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleQueryChange = (e) => {
    setQuery(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setCurrentPage(1);

    axios
      .post(
        "api/system/console",
        { userQuery: query },
        {
          headers: {
            "x-auth-token": token,
          },
        }
      )
      .then((res) => {
        setAllAlertsData(res.data);
      })
      .catch((err) => {
        console.error("Error during API call:", err);
        setError(err.response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showTableTabs = (item) => {
    if (tableTab === "table") {
      return (
        <div className="p-6 text-lg">
          <table className="table-fixed">
            <tbody className="text-center">
              {item._source.agent &&
                Object.entries(item._source.agent).map((entry) => {
                  let key = entry[0];
                  let value = entry[1];
                  return (
                    <tr>
                      <td className="p-2">agent.{key}</td>
                      <td>{value}</td>
                    </tr>
                  );
                })}
              {item._source.GeoLocation &&
                item._source.GeoLocation.location &&
                Object.entries(item._source.GeoLocation.location).map(
                  (entry) => {
                    let key = entry[0];
                    let value = entry[1];
                    return (
                      <tr>
                        <td>GeoLocation.{key}</td>
                        <td>{value}</td>
                      </tr>
                    );
                  }
                )}

              {item._source.decoder &&
                Object.entries(item._source.decoder).map((entry) => {
                  let key = entry[0];
                  let value = entry[1];
                  return (
                    <tr>
                      <td>decoder.{key}</td>
                      <td>{value}</td>
                    </tr>
                  );
                })}
              {item._source.input &&
                Object.entries(item._source.input).map((entry) => {
                  let key = entry[0];
                  let value = entry[1];
                  return (
                    <tr>
                      <td>input.{key}</td>
                      <td>{value}</td>
                    </tr>
                  );
                })}
              {item._source.manager &&
                Object.entries(item._source.manager).map((entry) => {
                  let key = entry[0];
                  let value = entry[1];
                  return (
                    <tr>
                      <td>manager.{key}</td>
                      <td>{value}</td>
                    </tr>
                  );
                })}
              {item._source.rule && item._source.rule.mitre
                ? Object.entries(item._source.rule.mitre).map((entry) => {
                    let key = entry[0];
                    let value = entry[1];
                    return (
                      <tr>
                        <td>rule.mitre.{key}</td>
                        {key === "technique" || key === "tactic" ? (
                          <td>{value.map((item) => item + " ")}</td>
                        ) : (
                          <td>{value}</td>
                        )}
                      </tr>
                    );
                  })
                : Object.entries(item._source.rule).map((entry) => {
                    let key = entry[0];
                    let value = entry[1];
                    return (
                      <tr>
                        <td>rule.{key}</td>
                        {key === "groups" || key === "tsc" ? (
                          <td>{value.map((item) => item + " ")}</td>
                        ) : (
                          <td>{value}</td>
                        )}
                      </tr>
                    );
                  })}
            </tbody>
          </table>
        </div>
      );
    } else if (tableTab === "json") {
      return (
        <div>
          <pre>
            <code>{JSON.stringify(item._source, undefined, 2)}</code>
          </pre>
        </div>
      );
    } else if (tableTab === "rule") {
      return <div>RULE</div>;
    }
  };

  const showAlertsData = (alertsData) => {
    const indexOfLastPage = currentPage * postsPerPage;
    const indexOfFirstPage = indexOfLastPage - postsPerPage;
    const currentPosts = alertsData.slice(indexOfFirstPage, indexOfLastPage);

    try {
      return currentPosts.map((item, index) => {
        return (
          <>
            <tr
              key={index}
              onClick={() =>
                dropdownIndex === index
                  ? setDropdownIndex(-1)
                  : setDropdownIndex(index)
              }
              className={`border border-black text-center cursor-pointer ${
                dropdownIndex === index ? "bg-[aliceblue]" : null
              }`}
            >
              <td className="border border-black p-2">
                {dropdownIndex === index ? (
                  <i class="ri-arrow-down-wide-line"></i>
                ) : (
                  <i class="ri-arrow-right-wide-line"></i>
                )}
              </td>
              <td className="border border-black p-2">
                {new Date(item._source.timestamp)
                  .toLocaleString()
                  .replace(",", "")}
              </td>
              <td className="border border-black p-2 text-[#0078a3]">
                {item._source.agent ? item._source.agent.id : "-"}
              </td>
              <td className="border border-black p-2">
                {item._source.agent ? item._source.agent.name : "-"}
              </td>
              <td className="border border-black p-2">
                {item._source.rule.mitre && item._source.rule.mitre.technique
                  ? item._source.rule.mitre.technique.map((item) => item + " ")
                  : "-"}
              </td>
              <td className="border border-black p-2">
                {item._source.rule.mitre && item._source.rule.mitre.tactic
                  ? item._source.rule.mitre.tactic.map((item) => item + " ")
                  : "-"}
              </td>
              <td className="border border-black p-2">
                {item._source.rule ? item._source.rule.description : "-"}
              </td>
              <td className="border border-black p-2">
                {item._source.rule ? item._source.rule.level : "-"}
              </td>

              <td className="border border-black p-2 text-[#0078a3]">
                {item._source.rule.id}
              </td>
            </tr>
            {dropdownIndex === index ? (
              <tr>
                <td>
                  <div>
                    <div className="flex gap-6 px-12 py-4">
                      <div
                        className={`text-lg font-semibold ${
                          tableTab === "table"
                            ? "border-b-2 border-blue-400 text-blue-400"
                            : null
                        } py-2`}
                        onClick={() => setTableTab("table")}
                      >
                        Table
                      </div>
                      <div
                        className={`text-lg font-semibold ${
                          tableTab === "json"
                            ? "border-b-2 border-blue-400 text-blue-400"
                            : null
                        } py-2`}
                        onClick={() => setTableTab("json")}
                      >
                        JSON
                      </div>
                      <div
                        className={`text-lg font-semibold ${
                          tableTab === "rule"
                            ? "border-b-2 border-blue-400 text-blue-400"
                            : null
                        } py-2`}
                        onClick={() => setTableTab("rule")}
                      >
                        Rule
                      </div>
                    </div>

                    {showTableTabs(item)}
                  </div>
                </td>
              </tr>
            ) : (
              ""
            )}
          </>
        );
      });
    } catch (e) {
      alert(e.message);
    }
  };

  const showAlertsPagination = (alertsData) => {
    const totalPosts = alertsData.length;
    const totalPages = Math.ceil(totalPosts / postsPerPage);
    const pageNumbers = [];

    // Helper function to add page numbers
    const addPageNumber = (number) => {
      if (number > 0 && number <= totalPages && !pageNumbers.includes(number)) {
        pageNumbers.push(number);
      }
    };

    // Always show the first two pages
    addPageNumber(1);
    addPageNumber(2);

    // Show dots if needed
    if (currentPage > 3) {
      pageNumbers.push("..."); // Dots before the middle
    }

    // Show middle pages
    for (
      let i = Math.max(3, currentPage - 1);
      i <= Math.min(totalPages - 2, currentPage + 1);
      i++
    ) {
      addPageNumber(i);
    }

    // Show dots if needed
    if (currentPage < totalPages - 2) {
      pageNumbers.push("..."); // Dots after the middle
    }

    // Always show the last two pages
    addPageNumber(totalPages - 1);
    addPageNumber(totalPages);

    const handlePageChange = (number) => {
      if (number !== "...") {
        setCurrentPage(number);
      }
    };

    return (
      <div className="mt-5 mb-12">
        <ul className="flex gap-2 flex-wrap justify-center">
          {pageNumbers.map((number, index) => (
            <li key={index}>
              <button
                onClick={() => handlePageChange(number)}
                className={`px-2 py-1 text-sm min-w-8 rounded-sm ${
                  currentPage === number
                    ? "bg-[#05123A] text-white"
                    : "bg-gray-400 text-black"
                }`}
                disabled={number === "..."}
              >
                {number}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const downloadAlertsExcel = (alertsData) => {
    let final = [];
    alertsData.map((item) =>
      final.push({
        Timestamp: new Date(item._source.timestamp)
          .toLocaleString()
          .replace(",", ""),
        Rule: item._source.rule?.id ?? "-",
        Description: item._source.rule?.description ?? "-",
        Level: item._source.rule?.level ?? "-",
        "Fired Times": item._source.rule?.firedtimes ?? "-",
        Groups: JSON.stringify(item._source.rule?.groups) ?? "-",
        "IP Address": item._source.agent?.ip ?? "-",
        Name: item._source.agent?.name ?? "-",
        ID: item._source.agent?.id ?? "-",
        "Source IP": item._source.data?.srcip ?? "-",
        Techniques: JSON.stringify(item._source.rule?.mitre?.technique) ?? "-",
        Tactics: JSON.stringify(item._source.rule?.mitre?.tactic) ?? "-",
        "Full Log": item._source?.full_log ?? "-",
        Location: item._source?.location ?? "-",
        GeoLocation: item._source?.GeoLocation?.country_name ?? "-",
        Coordinates: JSON.stringify(item._source?.GeoLocation?.location) ?? "-",
      })
    );
    const worksheet = XLSX.utils.json_to_sheet(final);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `alerts.xlsx`);
  };

  const showAlertsTable = (alertsData) => {
    if (loading)
      return (
        <div class="overflow-x-auto p-4">
          <div class="mb-4 text-center">
            <button class="w-48 h-12 bg-gray-300 rounded-md animate-pulse inline-block"></button>
          </div>
          <table class="min-w-full bg-white border border-gray-200">
            <thead class="bg-gray-200">
              <tr>
                <th class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </th>
                <th class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </th>
                <th class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </th>
                <th class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
              <tr>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
                <td class="p-3">
                  <div class="h-4 bg-gray-300 rounded animate-pulse"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    return (
      <div className="flex flex-col">
        <button
          className={`px-4 py-2 rounded-md text-white bg-[#05123A]  self-center my-6 md:my-4 ${
            alertsData.length > 0 ? "cursor-pointer" : "opacity-20"
          }`}
          onClick={() => downloadAlertsExcel(alertsData)}
          disabled={alertsData.length <= 0}
        >
          Download As Excel
        </button>
        {alertsData?.length > 0 ? (
          <>
            <div className="h-[60vh] text-sm md:text-md overflow-auto">
              <table className="text-left border-separate border-spacing-0 border-black table-fixed w-full">
                <thead className="text-center border border-black sticky top-0 z-50 bg-gray-200">
                  <tr>
                    <th className="border border-black p-2 w-[30px] md:w-[50px]"></th>
                    <th className="border border-black p-2 w-[100px]">Time</th>
                    <th className="border border-black p-2 w-[60px] md:w-[100px]">
                      Agent
                    </th>
                    <th className="border border-black p-2 w-[150px]">
                      Agent Name
                    </th>
                    <th className="border border-black p-2 w-[150px]">
                      technique(s)
                    </th>
                    <th className="border border-black p-2 w-[150px]">
                      tactic(s)
                    </th>
                    <th className="border border-black p-2 w-[200px]">
                      Description
                    </th>
                    <th className="border border-black p-2 w-[80px]">Level</th>
                    <th className="border border-black p-2 w-[100px]">
                      Rule ID
                    </th>
                  </tr>
                </thead>
                <tbody>{showAlertsData(alertsData)}</tbody>
              </table>
            </div>
            <div>{showAlertsPagination(alertsData)}</div>
          </>
        ) : (
          <div className="flex justify-center items-center h-[50vh] text-red-400"></div>
        )}
      </div>
    );
  };

  return (
    <div className="overflow-hidden lg:flex">
      <UserNavbar />

      <div className="px-4 lg:w-[80vw] xl:w-[85vw] lg:absolute lg:right-0 lg:px-6 xl:absolute xl:right-0 xl:px-16 xl:pt-20 xl:pb-12 h-full">
        <div class="bg-white p-4">
          <form class="flex items-center space-x-2" onSubmit={handleSubmit}>
            <input
              placeholder="rule.level: >10  AND agent.name: (agent1 OR agent2)"
              class="flex-1 p-6 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#b2ebff]"
              value={query}
              onChange={handleQueryChange}
            />
            <button
              className="p-8 bg-black text-white rounded-lg cursor-pointer hidden lg:flex hover:bg-red-600"
              type="submit"
            >
              Send
            </button>
          </form>
        </div>
        <div>
          {error.length > 0 ? (
            <div className="flex justify-center items-center text-red-400">
              {error}
            </div>
          ) : (
            showAlertsTable(allAlertsData)
          )}
        </div>
      </div>
    </div>
  );
};

export default QueryEditor;
